var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCsv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 51,
    viewBox: "0 0 42 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.8333 43H10.1667C7.83333 43 6 41.1348 6 38.7609V8.23913C6 5.86522 7.83333 4 10.1667 4H27.3333C28.5 4 29.6667 4.5087 30.5 5.52609L35 10.9522C35.6667 11.8 36 12.6478 36 13.6652V38.7609C36 41.1348 34.1667 43 31.8333 43Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8333 43H10.1667C7.83333 43 6 41.1348 6 38.7609V8.23913C6 5.86522 7.83333 4 10.1667 4H27.3333C28.5 4 29.6667 4.5087 30.5 5.52609L35 10.9522C35.6667 11.8 36 12.6478 36 13.6652V38.7609C36 41.1348 34.1667 43 31.8333 43Z",
    stroke: "#6DBB4C",
    strokeWidth: 0.870031,
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5436 24.1512C17.3559 22.5936 16.177 21.6979 14.6161 21.6979C12.8345 21.6979 11.4745 22.9558 11.4745 25.1621C11.4745 27.3619 12.8115 28.6264 14.6161 28.6264C16.3449 28.6264 17.3888 27.4771 17.5436 26.2356L16.1012 26.2291C15.9662 26.9502 15.3998 27.3652 14.6391 27.3652C13.615 27.3652 12.9201 26.6045 12.9201 25.1621C12.9201 23.7593 13.6051 22.9591 14.649 22.9591C15.4294 22.9591 15.9925 23.4102 16.1012 24.1512H17.5436ZM22.2246 23.7297H23.5912C23.5714 22.5277 22.5835 21.6979 21.0819 21.6979C19.6033 21.6979 18.5199 22.5145 18.5265 23.7395C18.5232 24.734 19.2246 25.3037 20.364 25.577L21.0984 25.7615C21.8327 25.9393 22.2411 26.15 22.2444 26.6045C22.2411 27.0984 21.7735 27.4343 21.049 27.4343C20.3081 27.4343 19.7746 27.0918 19.7285 26.4168H18.3487C18.3849 27.8756 19.4288 28.6297 21.0654 28.6297C22.712 28.6297 23.6801 27.8426 23.6834 26.6078C23.6801 25.4848 22.8338 24.8888 21.6615 24.6254L21.0556 24.4805C20.4694 24.3455 19.9788 24.1281 19.9886 23.644C19.9886 23.2094 20.3739 22.8899 21.072 22.8899C21.7537 22.8899 22.1719 23.1995 22.2246 23.7297ZM25.8609 21.7901H24.277L26.6051 28.5342H28.4427L30.7675 21.7901H29.1869L27.5535 26.914H27.491L25.8609 21.7901Z",
    fill: "#6DBB4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6667 4V10.7826C27.6667 12.6478 29.1667 14.1739 31.0001 14.1739H35.6667",
    stroke: "#6DBB4C",
    strokeWidth: 0.870031,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.344788,
    y: 0.0848186,
    width: 41.3104,
    height: 50.3105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.74006
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.61009
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsv);
export default __webpack_public_path__ + "static/media/csv.b294e2cc1a624d2eb05d516b9f3331b7.svg";
export { ForwardRef as ReactComponent };